import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function HightowerBorn() {
  const dateTexts = ['1825年', 'または', '1835年'];
  const dateAdditionalInfo = 'タワー・オブ・テラーのオープン当初は「1935年」という設定だったが、' +
    'イマジニアが作成した最新の資料では「1925年」となっている。'
  const title = 'ハイタワー三世誕生';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2017/09/harrison-hightower-iii.jpg'
  const description = (
    <>
      <a href='/harrison-hightower-iii'>
        {'ハリソンハイタワー三世'}
      </a>
      {'は、大富豪ハリソンハイタワー・ジュニアの息子としてニューヨークに生まれ、ニューヨークで１番の大富豪になる。'}
      {'探検家としても大規模に活動しており、生涯を通して世界各地を巡り美術品を収集する。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      dateAdditionalInfo={dateAdditionalInfo}
      title={title}
      description={description}
      imgUrl={imgUrl}
      objectPosition='20%'
    />
  );
}

export default HightowerBorn;
